import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { Trans } from "@lingui/react/macro";

interface ServerUnhealthyProps {
  isChecking: boolean;
  onRetry: () => void;
}

export const ServerUnhealthy = ({
  isChecking,
  onRetry,
}: ServerUnhealthyProps) => {
  return (
    <main className="absolute inset-0 flex flex-col items-center justify-center bg-white p-6 text-zinc-900 select-none dark:bg-zinc-950 dark:text-zinc-50">
      {/* 503 Status Code matching the 404 font-mono styling in NotFound.tsx */}
      <h1 className="font-mono text-5xl font-medium">503</h1>

      <h2 className="pt-4 text-lg font-bold">
        <Trans>서버와 연결할 수 없습니다</Trans>
      </h2>

      <p className="max-w-xs pt-2 pb-8 text-center text-sm leading-relaxed text-zinc-600 dark:text-zinc-400">
        <Trans>
          요기콕콕 서버가 점검 중이거나 네트워크 연결이 끊어졌습니다. 잠시 후
          다시 시도해 주세요.
        </Trans>
      </p>

      {/* Flat, solid button matching NotFound.tsx layout */}
      <button
        className={`flex cursor-pointer items-center gap-2 rounded-xl bg-black px-6 py-4 text-white duration-300 active:opacity-60 dark:bg-zinc-800 ${
          isChecking ? "pointer-events-none opacity-60" : ""
        }`}
        disabled={isChecking}
        onClick={onRetry}
        type="button"
      >
        <ArrowPathIcon
          className={`size-5 ${isChecking ? "animate-spin" : ""}`}
        />
        <span>
          {isChecking ? (
            <Trans>연결 확인 중...</Trans>
          ) : (
            <Trans>다시 시도</Trans>
          )}
        </span>
      </button>
    </main>
  );
};
